// @ts-nocheck
import { useMemo } from 'react';
import { StylesConfig, OptionTypeBase } from 'react-select';
import { useTheme } from 'styled-components';

export const useCustomStyles = <T extends OptionTypeBase>(
  notSeparated?: boolean,
  isError?: boolean,
  isAsyncSelect?: boolean,
  hasPrefixIcon?: boolean
): StylesConfig<T, false> => {
  const theme = useTheme();

  return useMemo<StylesConfig<T, false>>(
    () => ({
      container: (provided) => ({
        ...provided,
      }),
      control: (provided, { menuIsOpen, isDisabled }) => ({
        ...provided,
        backgroundColor: 'var(--surface)',
        color: 'var(--ink)',
        borderRadius: notSeparated
          ? menuIsOpen
            ? 'var(--r-md) var(--r-md) 0 0'
            : 'var(--r-md)'
          : 'var(--r-md)',
        padding: '0 0.875rem',
        borderColor: isError
          ? 'var(--danger)'
          : notSeparated
          ? 'var(--line)'
          : 'var(--line)',
        borderWidth: '1px',
        boxShadow: 'none',
        minHeight: '38px',
        height: '38px',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        cursor: 'pointer',
        fontSize: '0.875rem',
        fontWeight: 500,
        letterSpacing: '-0.005em',
        transition:
          'border-color 160ms ease, box-shadow 160ms ease',
        svg: {
          height: '1em',
          width: '1em',
          fill: 'currentColor',
          fontSize: notSeparated ? '0.95rem' : '0.75rem',
        },
        opacity: isDisabled ? 0.5 : 1,
        '&:hover': {
          borderColor: 'var(--brand-green)',
        },
        ...(menuIsOpen && {
          borderColor: 'var(--brand-green)',
          boxShadow: '0 0 0 3px rgba(118,177,89,0.15)',
        }),
      }),
      indicatorSeparator: () => ({
        display: 'none',
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: theme.zindexes.selectMenu,
        margin: notSeparated ? '0' : '0.375rem 0',
        boxShadow: theme.shadows.dropdown,
        borderRadius: notSeparated ? '0 0 0.5rem 0.5rem' : '0.5rem',
        borderColor: 'rgba(0,0,0,0.1)',
        overflow: 'hidden',
      }),
      menuList: (provided) => ({
        ...provided,
        zIndex: theme.zindexes.selectMenu,
        padding: 0,
      }),
      valueContainer: (provided) => ({
        ...provided,
        padding: 0,
        paddingLeft: hasPrefixIcon ? '20px' : 0,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginRight: '1rem',
        '> div': {
          width: '100%',
          height: '100%',
        },
        '> div > span': {
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      }),
      option: (provided, state) => ({
        ...provided,
        cursor: 'pointer',
        zIndex: theme.zindexes.selectMenu,
        transition: '250ms ease-in-out',
        padding: notSeparated
          ? '0.5rem 1.25rem 0.5rem 1.125rem'
          : '0.5rem 0.875rem',
        backgroundColor: state.isSelected
          ? 'var(--brand-green-soft)'
          : 'transparent',
        color: state.isSelected ? 'var(--ink)' : 'inherit',
      }),
      placeholder: (provided) => ({
        ...provided,
        color: 'inherit',
        margin: 0,
        height: 'fit-content !important',
        ...(isAsyncSelect ? { lineHeight: 1.5 } : {}),
      }),
      singleValue: (provided) => ({
        ...provided,
        height: 'fit-content !important',
        ...(isAsyncSelect ? { lineHeight: 1.5 } : {}),
      }),
    }),
    [isError, notSeparated, isAsyncSelect, hasPrefixIcon, theme.zindexes.selectMenu, theme.shadows.dropdown]
  );
};
